import React, { useEffect, useRef, useState } from 'react';
import {
  CreateFloorLayout,
  CreateTowerLayoutLevel,
  FacadePolygon,
  FloorLayoutDetail,
} from '../models/towerLayoutModel';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import { createLevelFloorEndpoint, createPolygonTowerLevel, polygonDetailFloorEndpoint } from '../../withdrawal/services/projectService';
import useAuth from '../../../hooks/useAuth';
import { useNavigate, useParams } from 'react-router-dom';
import { listToSelectOptionAdapter } from '../../../adapters/listAdapter';
import { PROJECT_DISTRIBUTION_LIST } from '../constants/towerLayoutConstants';
import { Option } from '../../../models/formModel';
import { getUnitsForModelEndpoint } from '../services/investorService';
import { getImageSize, ImageSize } from '../../../helpers/imageDimentionsHelpers';

const useProjectFloorLayout = () => {
  const distributionStatusOptions = listToSelectOptionAdapter(
    PROJECT_DISTRIBUTION_LIST,
    'value',
    'display_value',
  );
  const { id = '', id_dist = '' } = useParams();
  const [currentBack, setCurrentBack] = useState<boolean>(false)
  const [imageSize, setImageSize] = useState<ImageSize | null>(null);
  const [floorInfo, setFloorInfo] = useState<FloorLayoutDetail>();
  const [units, setUnits] = useState<any[]>([])
  const [points, setPoints] = useState<FacadePolygon[]>([]);
  const [selectPolygonStatus, setSelectPolygonStatus] = useState<Option>()
  const [isDrawing, setIsDrawing] = useState(false);
  const [isEditing, setIsEditing] = useState(false); // Nuevo estado
  const canvasRef = useRef(null);
  const { callEndpoint, isLoading } = useCallApiAndLoad();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const navigate = useNavigate()

  const {
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    register,
    reset,
  } = useForm<CreateFloorLayout>({
    resolver: yupResolver(
      yup
        .object({
          unit_id: yup.string().required('Debes seleccionar una unidad'),
        })
        .required(),
    ),
  });

  const loadPolygonTowerData = async (
    id: string
  ) => {
    const { status, data: responseData } = await callEndpoint(
        polygonDetailFloorEndpoint(id, id_dist, token),
    );

    if (status === 200) {
      setFloorInfo(responseData?.data)
    }
    
  }

  const loadUnitsModelsData = async (id: string) => {
    const { status, data: responseData } = await callEndpoint(
        getUnitsForModelEndpoint(id, token)
    )

    if (status === 200) {
        setUnits(responseData?.data)
    }
  }

  const addCurrentImage = async (form: any) => {
    console.log(form)
  }

  /* -- Load and preload info -- */

  // 1- Load tower information

  // 2-  Load canvas and catch updates when we are drawing

  const fetchImageSize = async (image: string) => {
    try {
      if (image) {
        const size = await getImageSize(image);
        console.log('medidas', size);
        setImageSize(size);
        return size;
      }
    } catch (error) {
      console.error('Error al cargar la imagen:', error);
    }
  };

  
  useEffect(() => {
    if (!floorInfo) {
      return;
    }
    if (!floorInfo.level_facade_background) {
        setCurrentBack(true)
    }

    fetchImageSize(floorInfo.level_facade_background).then((size) => {
const canvas: any = canvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const img = new Image();
      img.src = floorInfo.level_facade_background || floorInfo?.recommended_level_facade_background;
      img.onload = () => {
        ctx.globalAlpha = 0.5;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ctx.globalAlpha = 1.0;

        if (floorInfo.unit_distribution.length) {
            floorInfo.unit_distribution.forEach((d: any, index) => {
              if (d.status === "available") {
                ctx.strokeStyle = '#2FB672';
                ctx.fillStyle = 'rgba(47, 182, 114, 0.2)';
              } else {
                ctx.strokeStyle = 'red';
                ctx.fillStyle = 'rgba(229, 0, 0, 0.2)';
              }
     
            const { polygon } = d;
            console.log({d})
            ctx.beginPath();
            ctx.moveTo(polygon[0].x, polygon[0].y);
            polygon.slice(1).forEach((point: any) => ctx.lineTo(point.x, point.y));
            ctx.closePath();
            ctx.stroke();
            ctx.fill();
            d.index = index; // Asigna el índice sin modificar el objeto original
          });
        }

        if (points.length > 1 && isDrawing) {
          ctx.strokeStyle = 'green';
          ctx.beginPath();
          ctx.moveTo(points[0].x, points[0].y);
          for (let i = 1; i < points.length; i++) {
            ctx.lineTo(points[i].x, points[i].y);
          }
          ctx.lineTo(points[0].x, points[0].y);
          ctx.lineWidth = 3;
          ctx.stroke();
          ctx.fillStyle = 'rgba(229, 255, 204, 0.2)';
          ctx.fill();
        }
      };
    }
    })
    
  }, [points, isDrawing, floorInfo]);

  /* -- Handlers -- */

  // This put a pin of a shape that is being drawn
  const handleClick = (event: any) => {
    const canvas: any = canvasRef.current;
    if (canvas) {
      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const ctx = canvas.getContext('2d'); // Aquí definimos el contexto

      if (isEditing && floorInfo) {
        floorInfo.unit_distribution.forEach((d, index) => {
          const path = new Path2D();
          path.moveTo(d.polygon[0].x, d.polygon[0].y);
          d.polygon.slice(1).forEach((point) => path.lineTo(point.x, point.y));
          path.closePath();
          
          if (ctx.isPointInPath(path, x, y)) {
            console.log('Polígono seleccionado:', d, 'Índice:', index); // Información del polígono y su índice

            // setValue('level', d.level);
            const selectedStatus = distributionStatusOptions.find((option) => option.value === d.status)
            if (selectedStatus) {
              setSelectPolygonStatus(selectedStatus)
            }
            
            // setValue('status', d.status);
            setValue('polygon', d.polygon)

          }
        });
      } else if (isDrawing) {
        setPoints([...points, { x, y }]);
      } else {
        setPoints([{ x, y }]);
        setIsDrawing(true);
      }
    }
  };

  const resetForm = () => {
    // TODO clear canvas and clear form
    setPoints([]) // This clear the canvas
  };

  const sendLevelToCreate = async (form: CreateFloorLayout) => {
    if (points.length <= 2) {
      // TODO define a SweetAlert error
      alert('Polígono no fue encontrado, debes dibujar uno');
      return;
    }
    // close polygon before create
    const closedPolygon = [...points, points[0]];
    setPoints(closedPolygon); // Close the polygon
    setIsDrawing(false);
    form.polygon = closedPolygon;

    const { status, data } = await callEndpoint(createLevelFloorEndpoint(id, id_dist, form, token));
    if (status === 200) {
    alert('El poligono fue creado con exito')
    }
    navigate(0)
    console.log({ form });
  };

  const sendLevelToUpdate = async (form: CreateFloorLayout) => {
    
    // close polygon before create
    setIsDrawing(false);
    const { status, data } = await callEndpoint(createLevelFloorEndpoint(id, id_dist, form, token));
    if (status === 200) {
      alert('El poligono fue actualizado con exito')
    }
    navigate(0)
    console.log({ form });
  };

  return {
    // Form
    currentBack,
    setIsEditing,
    isEditing,
    register,
    handleSubmit,
    errors,
    control,
    setValue,
    sendLevelToCreate,
    resetForm,
    isLoading,
    floorInfo,
    canvasRef,
    handleClick,
    points,
    loadPolygonTowerData,
    selectPolygonStatus,
    sendLevelToUpdate,
    loadUnitsModelsData,
    imageSize,
    units
  };
};

export default useProjectFloorLayout;
